import OnboardingDialogLayout from "@components/layouts/Onboarding/components/OnboardDialogLayout";
import { RegisterPP } from "@components/utils/Auth";
import { OnboardingDialogStep } from "@components/utils/OnboardingDialog/constants";
import { OnboardingStepProps } from "@components/utils/OnboardingDialog/types";
import { usePostLoginHandler } from "@hooks/usePostLoginHandler";
import { useTranslation } from "react-i18next";

interface RegisterStepProps extends OnboardingStepProps {}

const RegisterStep = ({ navigate, handleClose, layout }: RegisterStepProps) => {
  const { t } = useTranslation();
  const { registerFlowHandlers } = usePostLoginHandler({
    flowMode: "dialog",
    registerFlowConfigs: {
      navigateStep: navigate,
    },
  });

  return (
    <OnboardingDialogLayout
      layout={layout}
      pageTitle={t("register")}
      navigation={{
        close: {
          onClick: handleClose,
        },
        back: {
          onClick: () => navigate(OnboardingDialogStep.Onboarding),
        },
      }}
      features={{
        showCloseButton: true,
        showBackButton: true,
      }}
    >
      <RegisterPP
        onLoginSuccess={registerFlowHandlers.handleLoginSuccess}
        onPostLoginCheckFailed={registerFlowHandlers.handlePostLoginCheckFailed}
        onPostLoginCheckPassed={registerFlowHandlers.handlePostLoginCheckPassed}
      />
    </OnboardingDialogLayout>
  );
};

export default RegisterStep;
